const api = process.env.VUE_APP_API_URL;
const cf = process.env.VUE_APP_IP_COUNTRY_API;
export const base_bome = api + "/v2";
export const base_cf = cf + "/api";
